export const defaultReconnectChatPaneStartNewChatButtonHoveredStyles = {
  backgroundColor: "rgb(132, 132, 130)"
};